import { Link } from "react-router-dom";
import { ArrowRight, Calendar } from "lucide-react";
import Seo from "@/components/Seo";
import Breadcrumbs from "@/components/layout/Breadcrumbs";
import CtaBand from "@/components/sections/CtaBand";
import { useBlogs } from "@/hooks/usePublicData";

export default function Blog() {
  const { data: blogs = [] } = useBlogs();
  return (
    <>
      <Seo title="Rajasthan Travel Blog & Taxi Guides | Chouhan Taxi Service"
        description="Travel tips, taxi guides and sightseeing ideas for Jodhpur, Jaipur, Udaipur and Jaisalmer from Chouhan Taxi Service."
        path="/blog" />
      <Breadcrumbs items={[{ label: "Blog" }]} />
      <section className="pt-8">
        <div className="container-x max-w-3xl">
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-heading font-extrabold text-navy-heading leading-tight">Travel Blog & Taxi Guides</h1>
          <p className="mt-4 text-slate-600 leading-relaxed">Practical guides, travel tips and destination ideas to help you plan the perfect Rajasthan trip.</p>
        </div>
      </section>
      <section className="section-pad pt-10">
        <div className="container-x">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
            {blogs.map((b) => (
              <Link key={b.slug} to={`/blog/${b.slug}`} data-testid={`blog-card-${b.slug}`}
                className="group bg-white rounded-2xl overflow-hidden border border-slate-100 shadow-sm card-hover">
                <div className="h-48 overflow-hidden"><img src={b.image} alt={b.title} loading="lazy" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" /></div>
                <div className="p-6">
                  <div className="text-xs text-brand font-semibold uppercase tracking-wider mb-2">{b.category}</div>
                  <h2 className="font-heading font-semibold text-navy-heading text-lg leading-snug group-hover:text-brand transition-colors">{b.title}</h2>
                  <p className="mt-2 text-sm text-slate-600 leading-relaxed line-clamp-2">{b.excerpt}</p>
                  <span className="mt-3 text-sm text-brand font-semibold inline-flex items-center gap-1 group-hover:gap-2 transition-all">Read more <ArrowRight className="w-3.5 h-3.5" /></span>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>
      <CtaBand />
    </>
  );
}
